import Swiper from 'swiper';

new Swiper('.kn-content-section-17 .swiper-container', {
  slidesPerView: 'auto',
  freeMode: true
});

// set jQuery
console.log('test');
const $ = window.jQuery;


$(".faq-button").on('click', function(event){
  $('.faq').removeClass("faq-active");
  $(this).addClass("faq-active");
  $('.faq').removeClass("faq-active");
  $('#item-'+$(this).attr('id')).addClass("faq-active");

});


$(function(){
  $(".slidedown-link").click(function (e) {
    $('.slidedown-contain-' + $(this).attr("id")).slideToggle();
    $(this).toggleClass("active");
    $(this).find("span").html($(this).find("span").html() === "+" ? "-" : "+");
    //$(this).find("span").html($(this).find("span").html() === "⯅" ? "⯆" : "⯅");
  });
});